import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";
import { INITIAL_REDUCER_DATA, IReducerWithIsolated } from "@/main/services/reducerUtils";
import { ReportTemplateTypeState } from "./reportTemplateTypeTypes";

export const useReportTemplateTypeReducer = (keyReducer: string = "default") => {
	const returnSelector = useSelector((state: ApplicationState) => state.reportTemplateType);
	if (keyReducer === "default") return returnSelector as IReducerWithIsolated<ReportTemplateTypeState>;

	const updateState = {
		...returnSelector,
		isolated: returnSelector.isolated[keyReducer] ?? INITIAL_REDUCER_DATA,
	};

	return updateState as IReducerWithIsolated<ReportTemplateTypeState>;
};
